// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_O6N","cls2":"PaperBrowserPreviewList-cls2_pFR PaperBrowserPreviewList-cls1_O6N"};